module.exports = __webpack_public_path__ + "img/newsImg.52df53ad.png";